<template>
  <div class="progress-wrap">
    <!-- 搜索 -->
    <div class="search-wrap">
      <div class="wrapper">
        <!-- 面包屑 -->
        <div class="breadcrumb-wrap clearfix">
          <div class="breadcrumb arrow inverted pull-left">
            <div class="start">当前位置：</div>
            <a href="index.html">首页</a>
            <div class="divider">&gt;</div>
            <a href="#">实习进度</a>
            <div class="divider">&gt;</div>
            <a href="#">进度查询</a>
          </div>
        </div>
        <!-- 搜索 -->
        <h3 class="title">申请实习进度查询</h3>
        <div class="search-input-wrap clearfix">
          <div class="search-btn pull-left">
            <i class="iconfont icon-sousuo"></i>
          </div>
          <input type="text" class="input-text pull-left" placeholder="请输入申请实习编号/身份证号码">
          <div class="search-text-btn pull-right">
            搜索
          </div>
        </div>
      </div>
    </div>
    <!-- 信息 -->
    <div class="message-wrap">
      <div class="wrapper">
        <!-- title -->
        <div class="mess-title">
          <div class="bing-wrap"></div>
          <span>基本信息</span>
        </div>
        <!-- table -->
        <table class="mess-table">
          <tr>
            <td>姓名： 王大毛</td>
            <td>申请实习机构： 上海市xx律师协会</td>
            <td>申请指导律师：李国立</td>
          </tr>
          <tr>
            <td>资格证号： 123123123</td>
            <td>申请日期： 2018-11-01</td>
            <td></td>
          </tr>
        </table>
        <!-- 进度 -->
        <div class="mess-title">
          <div class="bing-wrap"></div>
          <span>申请进度</span>
        </div>
        <speed-progress
        :outList="listArr"
        ></speed-progress>
      </div>
    </div>
  </div>
</template>

<script>
  import speedProgress from "../components/speed-progress.vue";
  import { mapGetters, mapActions } from "vuex";
  export default {
    components: {
      speedProgress
    },
    name: "progress-wrap",
    data() {
      return {
        listArr: [
          { name: '网上发起申请', act: true },
          { name: '提交材料', act: false },
          { name: '协会受理', act: false },
          { name: '协会审核通过', act: false },
          { name: '协会制证完成', act: false },
          { name: '完成发证', act: false }
        ]
      };
    },
    methods: {
      ...mapActions([])
    },
    watch: {
    },
    computed: {
      ...mapGetters([])
    },
    created() { },
    mounted() { }
  };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" rel="stylesheet/scss">
  @import "../assets/scss/variables";
  @import "../assets/scss/mixins";

  .progress-wrap {
    width: 100%;
    height: auto;
    .message-wrap .wrapper {
      padding-bottom: 70px;
    }
  }
</style>